import Link from 'components/gruenland/atoms/link';
import { User } from 'components/gruenland/icons/User';
import { AccountContext } from 'context/account';
import { useFormat } from 'helpers/hooks/useFormat';
import { useContext } from 'react';

const AccountButton: React.FC<{ className?: string }> = ({ className }) => {
  const { account } = useContext(AccountContext);
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const title = account
    ? formatMessage({ id: 'account.title', defaultMessage: 'Account' })
    : formatMessage({ id: 'login.title', defaultMessage: 'Login' });

  return (
    <div className={className}>
      <Link link={account ? '/account' : '/login'} title={title}>
        <User />
      </Link>
    </div>
  );
};

export default AccountButton;
